import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { PRODUCT_OFFERS } from 'registry/constants'
import { setActiveModal } from 'registry/actions'
import Clickable from 'components/clickable'

export const BuyingOptionsLink = ({
  brand,
  children,
  className,
  imageUrl,
  name,
  offers,
  productId,
  regItemId,
  setActiveModal,
  openRedirectModal,
}) => {
  const openProductOffersModal = () => {
    setActiveModal(PRODUCT_OFFERS, {
      brand,
      imageUrl,
      name,
      offers,
      productId,
      regItemId,
      openRedirectModal,
    })
  }
  return (
    <Clickable className={className} onClick={openProductOffersModal}>
      {children}
    </Clickable>
  )
}

BuyingOptionsLink.propTypes = {
  brand: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  offers: PropTypes.array.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  productId: PropTypes.number,
  regItemId: PropTypes.number,
  setActiveModal: PropTypes.func.isRequired,
}

BuyingOptionsLink.defaultProps = {
  brand: undefined,
  className: undefined,
  productId: undefined,
  regItemId: undefined,
}

export default connect(undefined, { setActiveModal })(BuyingOptionsLink)
